let type_product = null

jQuery(function ($) {

    console.log("load subscriptions");

    setTimeout(function(){
      $(document).on("click", "a.card-sub-link", function(e){

          console.log("stopLinking");
          e.preventDefault();
          e.stopPropagation();

          const handle = $(this).data("handle");
          console.log("a.card-sub-link");

          if( handle == "deluxe-car-diffuser"){
            open_carDiffuserModal()
          }else{
            openDiffuserModal();
          }
          
          if (handle) {
              setTimeout(function(){
                  const $scent = $("#diffuser-scent");

                  // only set if option exists
                  if ($scent.find(`option[value="${handle}"]`).length) {
                      $scent.val(handle).trigger("change");
                  }
              }, 50);
          }
      });
     }, 3000);

    $("#diffuser-duration").on("change", function () {

      const value = this.value;
      const button = document.getElementById("diffuser-add-cart");

      if (value === "0") {
        button.textContent = "Add to Cart";
      } else {
        button.textContent = "Add Subscription";
      }

    });

    $(document).on("click", "#diffuser-scent .scent-selected", function(e){
      e.stopPropagation();
      $("#diffuser-scent").toggleClass("active");
    });


    $(document).on("click", ".scent-option", function(){
      
        const handle = $(this).data("handle");
        const variant_id = $(this).data("variant-id")
        console.log("scent-option-selected",variant_id)
        $(".scent-selected").html($(this).html());
        $("#diffuser-scent").attr("value", handle);
        $("#diffuser-scent").attr("variant-id", variant_id)
        $("#diffuser-scent").removeClass("active");


        const $sizeSelect = $("#diffuser-size");
        $sizeSelect.html('<option value="">Select size</option>');

        const product = fragranceData.find(p => p.handle === handle);

        if(type_product == "car-diffuser"){return}

        if(!product) return;

        const sizes = new Set();

        product.variants.forEach(v => {
          if(v.option1) sizes.add(v.option1);
        });

        sizes.forEach(size => {
          $sizeSelect.append(
            $("<option>", { value: size, text: size })
          );
        });

    });

});


const fragranceData = JSON.parse(
  document.getElementById("fragrance-data").textContent
);

function loadScents(){

  const container = document.getElementById("diffuser-scent");

  container.innerHTML = `
    <div class="scent-selected">Select scent</div>
    <div class="scent-dropdown"></div>
  `;

  const dropdown = container.querySelector(".scent-dropdown");

  fragranceData.forEach(product => {

    if(product.handle != "smart-car-diffuser-cartridge-oil-1"){
      const item = document.createElement("div");
      item.className = "scent-option";
      item.dataset.handle = product.handle;

      item.innerHTML = `
        <div class="scent-title">${product.title}</div>
        ${product.inspired ? `<div class="scent-inspired">Inspired by: ${product.inspired}</div>` : ""}
        ${product.notes ? `<div class="scent-notes">${product.notes}</div>` : ""}
      `;

      dropdown.appendChild(item);
    }
  });
  
}



function car_loadScents(){
  console.log("load car scents")
  const container = document.getElementById("diffuser-scent");

  container.innerHTML = `
    <div class="scent-selected">Select scent</div>
    <div class="scent-dropdown"></div>
  `;

  const dropdown = container.querySelector(".scent-dropdown");

  // 👉 find the cartridge product
  const scentProduct = fragranceData.find(p => 
    p.handle === "smart-car-diffuser-cartridge-oil-1"
  );

  if (!scentProduct || !scentProduct.variants) {
    console.warn("Scent product or variants not found");
    return;
  }

  console.log("scentProduct",scentProduct)
  // 👉 loop variants instead of products
  scentProduct.variants.forEach(variant => {

    const item = document.createElement("div");
    item.className = "scent-option";

    item.dataset.handle = scentProduct.handle;
    item.dataset.variantId = variant.id;

    console.log("variant",variant)

     item.innerHTML = `
      <div class="scent-title">${variant.title}</div>
      ${variant.inspired ? `<div class="scent-inspired">Inspired by: ${variant.inspired}</div>` : ""}
      ${variant.notes ? `<div class="scent-notes">${variant.notes}</div>` : ""}
    `;

    dropdown.appendChild(item);
  });

}


document.getElementById("diffuser-add-cart").addEventListener("click", function(){

  if(type_product == "diffuser"){
    const scent = $("#diffuser-scent").attr("value");
    const size = document.getElementById("diffuser-size").value;
    const sellingPlan = document.getElementById("diffuser-duration").value;
    const product = fragranceData.find(p => p.handle === scent);

    if(!product) return;
    const variant = product.variants.find(v => v.option1 === size);
    if(!variant) return;

    addDiffuserToCart(variant.id, sellingPlan);
  }else{
    const variant_id = $("#diffuser-scent").attr("variant-id");
    const sellingPlan = document.getElementById("diffuser-duration").value;
    if(!variant_id) return;
    
    addDiffuserToCart(variant_id, sellingPlan);
  }

});

function addDiffuserToCart(variantID, sellingPlan){
  const input_qty = document.querySelector(".m-quantity__input")?.value || 1;
  const payload = { id: variantID, quantity: input_qty };

  if (sellingPlan && sellingPlan > 0) {
    payload.selling_plan = sellingPlan;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  })
  .then(() => {
    document.dispatchEvent(
      new CustomEvent('cart:refresh', { detail: { open: true } })
    );
  });

}


/* this fix subcriptions to fragences */
document.addEventListener("click", function(e){

  const btn = e.target.closest('button[name="add"]');
  if (!btn) return;

  if (!window.productTags) return;

  const tags = window.productTags.map(t => t.toLowerCase());
  const params = new URLSearchParams(window.location.search);
  const sellingPlan = params.get("selling_plan");
  const variantID = params.get("variant"); 

  /* -------------------------
     DIFFUSER PRODUCT
     allow normal add-to-cart
     This also call the subscription model
  ------------------------- */

  if (tags.includes("diffuser")) {
    console.log("tags.includes(diffuser)");
    openDiffuserModal();
    return;
  }

  if(tags.includes("car-diffuser")){
    console.log("open car diffuser model")
    open_carDiffuserModal();
    return;
  }

  /* -------------------------
     FRAGRANCE OIL PRODUCT
     override add-to-cart
  ------------------------- */ 

  if (tags.includes("fragranceoil") && sellingPlan) {

    e.preventDefault();
    e.stopImmediatePropagation();

    const input_qty = document.querySelector(".m-quantity__input")?.value || 1;

    const payload = {
      id: variantID,
      quantity: input_qty,
      selling_plan: sellingPlan
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(() => {
      document.dispatchEvent(
        new CustomEvent('cart:refresh', { detail: { open: true } })
      );
    });

  }

});

function applySubscriptionVariant(variantID){

  const form = document.querySelector('form[action="/cart/add"]');

  const input = form.querySelector('[name="id"]');

  input.value = variantID;

}

function openDiffuserModal(){  
    console.log("openDiffuserModal")
    type_product = "diffuser"
    $(".size_ui").show();
    const modal = document.getElementById("diffuser-subscription-modal");
    if(!modal) return;
    modal.classList.add("active");
    loadScents()
}

function open_carDiffuserModal(){
    $(".size_ui").hide();
    type_product = "car-diffuser"
    console.log("openDiffuserModal")
    const modal = document.getElementById("diffuser-subscription-modal");
    if(!modal) return;
    modal.classList.add("active");
    car_loadScents()
}



document.addEventListener("click", function(e){

  if(e.target.classList.contains("diffuser-close")){
    closeDiffuserModal();
  }

  if(e.target.id === "diffuser-subscription-modal"){
    closeDiffuserModal();
  }

});

function closeDiffuserModal(){

  const modal = document.getElementById("diffuser-subscription-modal");

  if(modal){
    modal.classList.remove("active");
  }

}

